import { Translate } from "react-i18nify";

export const Summary = ({ ...props }: SummaryProps): JSX.Element => {
    return (
        <>
            <p className="pb-5">
                <span className="title is-6 has-text-primary pr-3">{props.title}:</span>
                <span className="has-text-primary has-text-weight-bold">{props.score}</span>
            </p>
            {props.label1 && <p className="pb-5 pr-6">{props.label1}</p>}
            {props.label2 && <p className="pb-5 pr-6">{props.label2}</p>}
            {props.description && (
                <>
                    <h3 className="title is-6 mb-0">{props.descriptionTitle}</h3>
                    <p className="pb-5 pr-6">{props.description}</p>
                </>
            )}
            {props.clinicianComment && (
                <p className="pb-5 pr-6">
                    <span className="has-text-weight-bold">
                        <Translate value={"admin.scoring.headings.clinicalComment"} />{" "}
                    </span>
                    {props.clinicianComment}
                </p>
            )}
            {props.researchComment && (
                <p className="pb-5 pr-6">
                    <span className="has-text-weight-bold">
                        <Translate value={"admin.scoring.headings.researchComment"} />{" "}
                    </span>
                    {props.researchComment}
                </p>
            )}
            {props.clinicianFollowUp && (
                <>
                    <p className="has-text-weight-bold">
                        <Translate value={"admin.scoring.headings.clinicianFollowUp"} />:
                    </p>
                    <p className="pb-5 pr-6">{props.clinicianFollowUp}</p>
                </>
            )}
            {props.researchFollowUp && (
                <>
                    <p className="has-text-weight-bold">
                        <Translate value={"admin.scoring.headings.researchFollowUp"} /> :
                    </p>
                    <p className="pb-5 pr-6">{props.researchFollowUp}</p>
                </>
            )}
        </>
    );
};

interface SummaryProps {
    title: string | JSX.Element;
    score: number | string | JSX.Element;
    descriptionTitle?: string | JSX.Element;
    description?: string | JSX.Element;
    clinicianComment?: string | JSX.Element;
    researchComment?: string | JSX.Element;
    clinicianFollowUp?: string | JSX.Element;
    researchFollowUp?: string | JSX.Element;
    label1?: string | JSX.Element;
    label2?: string | JSX.Element;
}
